import {
   activeOrganisationId$,
   allowDataEntry$,
   characteristics$,
   consolidationMethod$,
   currency$,
   currencyCode$,
   customization$,
   isOrganisationActive$,
   maxValidTo$,
   minValidFrom$,
   organisationContextQuery,
   organisationId$,
   parentIds$,
   parents$,
   reducedContext$,
   reportingStandards$,
   results$,
   subsidiaries$,
   subsidiaryIds$,
   theme$,
   topLevelOrganisationId$,
   type$,
} from 'context/OrganisationContext/query';
import { loading$ } from 'context/UserContext/query';
import UsersService from 'state/User/service';

const api = new UsersService();

const facade = {
   api,
   query: organisationContextQuery,
   loading$,
   reducedContext$,
   parents$,
   subsidiaryIds$,
   isOrganisationActive$,
   allowDataEntry$,
   parentIds$,
   activeOrganisationId$,
   organisationId$,
   reportingStandards$,
   currencyCode$,
   type$,
   subsidiaries$,
   characteristics$,
   results$,
   consolidationMethod$,
   currency$,
   customization$,
   theme$,
   topLevelOrganisationId$,
   minValidFrom$,
   maxValidTo$,
};

export default facade;
